import * as types from "./types";
import * as statuses from "../../constants/invoiceStatuses";

import { isAllSelected } from "./helpers";

const invoicesState = {
  invoices: [],
  selectedInvoices: [],
  total: 0,
  noDataType: null,
  filters: {
    statusFilters: [
      {
        label: statuses.PAID,
        key: statuses.PAID,
        isActive: false
      },
      {
        label: statuses.PENDING,
        key: statuses.PENDING,
        isActive: false
      },
      {
        label: statuses.UNPAID,
        key: statuses.UNPAID,
        isActive: false
      },
      {
        label: statuses.VOID,
        key: statuses.VOID,
        isActive: false
      }
    ],
    typeFilters: [
      {
        label: "SHARED",
        key: "SHARED",
        isActive: false
      },
      {
        label: statuses.PENDING,
        key: "WARNING",
        isActive: false
      }
    ],
    exactSearch: false,
    from: null,
    to: null,
    criteria: ""
  },
  pagination: {
    pageRangeDisplayed: 4,
    activePage: 1,
    itemsCountPerPage: 10
  },
  order: {
    direction: "desc",
    columnKey: "createdAt"
  },
  error: null
};

export default (state = invoicesState, action) => {
  switch (action.type) {
    case types.FETCHING_INVOICE_LIST_SUCCESS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case types.FETCHING_INVOICE_LIST_ERROR: {
      return {
        ...state,
        error: action.payload
      };
    }
    case types.SET_ITEMS_COUNT_PER_PAGE: {
      const pagination = { ...invoicesState.pagination };
      pagination.itemsCountPerPage = action.payload;
      pagination.activePage = 1;

      return {
        ...state,
        selectedInvoices: [],
        pagination
      };
    }
    case types.RESET_STATE: {
      return {
        ...invoicesState
      };
    }
    case types.SET_PAGE: {
      const pagination = { ...state.pagination };
      pagination.activePage = action.payload;
      return {
        ...state,
        selectedInvoices: [],
        pagination
      };
    }
    case types.SET_ORDER: {
      const { columnKey, direction } = action.payload;
      let newDirection = null;

      if (columnKey === state.order.columnKey) {
        if (direction === "asc") newDirection = "desc";
        if (direction === "desc") newDirection = "asc";
      } else {
        newDirection = "asc";
      }

      return {
        ...state,
        selectedInvoices: [],
        order: { columnKey, direction: newDirection }
      };
    }
    case types.SET_FILTERS: {
      const { from, to } = action.payload;

      const filters = {
        ...state.filters,
        ...action.payload
      };
      if (from) {
        filters.from = from ? new Date(from).toISOString() : null;
      }
      if (to) {
        filters.to = to ? new Date(to).toISOString() : null;
      }

      const newState = {
        ...state,
        selectedInvoices: [],
        filters
      };
      newState.pagination.activePage = 1;

      return newState;
    }
    case types.APPLY_METADATA: {
      const data = action.payload;

      const statusFilters = state.filters.statusFilters.map(f => ({
        ...f,
        isActive: data.statusFilters ? data.statusFilters.some(key => key === f.key) : f.isActive
      }));

      const typeFilters = state.filters.typeFilters.map(f => ({
        ...f,
        isActive: data.typeFilters ? data.typeFilters.some(key => key === f.key) : f.isActive
      }));

      return {
        ...state,
        order: {
          columnKey: data.columnKey || state.order.columnKey,
          direction: data.direction || state.order.direction
        },
        pagination: {
          itemsCountPerPage: parseInt(data.itemsCountPerPage, 10) || state.pagination.itemsCountPerPage,
          pageRangeDisplayed: parseInt(data.pageRangeDisplayed, 10) || state.pagination.pageRangeDisplayed,
          activePage: parseInt(data.activePage, 10) || state.pagination.activePage
        },
        filters: {
          statusFilters,
          typeFilters,
          from: data.from || state.filters.from,
          to: data.to || state.filters.to,
          criteria: data.criteria || state.filters.criteria,
          exactSearch: data.exactSearch || state.filters.exactSearch
        }
      };
    }
    case types.SELECT_INVOICE: {
      const id = action.payload;

      let newSelections = [];

      const { invoices, selectedInvoices } = state;

      if (id === 0 && !isAllSelected(invoices, selectedInvoices)) {
        newSelections = state.invoices
          .filter(i => i.status === statuses.UNPAID && i.type !== "statement")
          .map(d => d.code);
      } else if (id !== 0) {
        newSelections = [...state.selectedInvoices];

        if (state.selectedInvoices.some(s => s === id)) {
          newSelections = newSelections.filter(s => s !== id);
        } else {
          newSelections.push(id);
        }
      }

      return {
        ...state,
        selectedInvoices: newSelections
      };
    }
    default:
      return state;
  }
};
